import axios from 'axios';
import { API_BASE_URL } from '../../confing.js/baseUrl';

// Create axios instance with default config
const apiClient = axios.create({
	baseURL: API_BASE_URL,
	timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
})

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const user = JSON.parse(sessionStorage.getItem('user'))
    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Create new blog post detail
const createBlogPost = async (data) => {
	 
	const response = await apiClient.post('/api/blog',data);

	return response.data;
};

// Get all  blog posts
const getBlogPosts = async () => {
	

	const response = await apiClient.get('/api/blog');
	return response.data;
};
// Get single  blog post
const getBlogPost = async (postId,token) => {

	const response = await apiClient.get('/api/blog',postId);

	return response.data;
};

// Delete single   blog post
const deleteBlogPost = async (postId,token) => {
	 

	const response = await apiClient.delete('/api/blog',postId);

	return response.data;
};
// edit single  blog post
const updateBlogPost = async (postId,token) => {
	
	const response = await apiClient.put('/api/blog', postId);

	return response.data;
};

const blogService = {
	createBlogPost,
	getBlogPosts,
	deleteBlogPost,
	updateBlogPost,
	getBlogPost
};

export default blogService;
